import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";

import "./styles/project.css";

const Project = (props) => {
	const {
		logo,
		title,
		description,
		linkText,
		link,
		imageData,
		logo2,
		logo3,
		logoArray,
	} = props;
	console.log(logoArray);
	return (
		<React.Fragment>
			<div className="project">
				<Link to={link}>
					<div className="project-container">
						<div
							style={{
								display: "flex",
								justifyContent: "flex-start",
								gap: "10px",
								alignItems: "center",
							}}
						>
							{logoArray.map((i) => {
								return (
									<div className="project-logo">
										<img src={i} alt="logo" />
									</div>
								);
							})}
						</div>
						<div className="project-title">{title}</div>
						<div
							className="project-description "
							align="justify"
							stlye={{ align: "justify" }}
						>
							{description}
						</div>
						<div className="project-description-img text-center">
							{imageData ? (
								<img
									src={imageData}
									alt="Your Image"
									style={{ maxWidth: "100%", height: "auto" }}
								/>
							) : null}
						</div>
						<div className="project-link">
							<div className="project-link-icon">
								<FontAwesomeIcon icon={faLink} />
							</div>

							<div className="project-link-text">{linkText}</div>
						</div>
					</div>
				</Link>
			</div>
		</React.Fragment>
	);
};

export default Project;
